export default{
    baseURL: 'https://backoffice.complexeelite.com/api', 
}